import { BetSelection, BetState } from '@/types/Bet';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: BetState = {
  selectedBet: null,
  stake: 0,
  acceptOddsChange: true,
};

export const betSlice = createSlice({
  name: 'bet',
  initialState,
  reducers: {
    setSelectedBet: (state, action: PayloadAction<BetSelection | null>) => {
      state.selectedBet = action.payload;
      state.stake = 0;
    },
    setStakeAmount: (state, action: PayloadAction<number>) => {
      state.stake = action.payload;
    },
    clearBet: (state, action: PayloadAction) => {
      state.selectedBet = null;
      state.stake = 0;
      state.acceptOddsChange = true;
    },
  },
});

export const { setSelectedBet, setStakeAmount, clearBet } = betSlice.actions;
